import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@cotyorg/ccx-atoms/Button';
import PaginationButtonContents from '../PaginationButtonContents';

const generateExtraButtonClass = ({
  isLine,
  isNumber,
  isThumbnail,
  isCircle,
}) => (
  classNames('carousel__pagination-button', {
    'carousel__pagination-button--line': isLine,
    'carousel__pagination-button--number': isNumber,
    'carousel__pagination-button--thumbnail': isThumbnail,
    'carousel__pagination-button--circle': isCircle,
  })
);

const onClick = ({
  setIndex,
  carouselsStoreDataKey,
  buttonIndex,
  onIndexChange,
  currentIndex,
}) => {
  setIndex({ carouselsStoreDataKey, index: buttonIndex });

  if (onIndexChange) {
    onIndexChange({
      type: 'PaginationButton',
      index: buttonIndex,
      currentIndex,
    });
  }
};

const PaginationButton = ({
  buttonIndex,
  carouselsStoreDataKey,
  setIndex,
  type,
  contents,
  currentIndex,
  onIndexChange,
  picture,
}) => {
  const isLine = type === 'lines';
  const isNumber = type === 'numbers';
  const isThumbnail = type === 'thumbnails';
  const isCircle = type === 'circles';

  return (
    <Button
      extraClass={generateExtraButtonClass({
        isLine,
        isNumber,
        isThumbnail,
        isCircle,
      })}
      onClick={() => onClick({
        setIndex,
        carouselsStoreDataKey,
        buttonIndex,
        onIndexChange,
        currentIndex,
      })}
      testAttribute={`carousel-pagination-${type}-button`}
    >
      <PaginationButtonContents
        type={type}
        buttonIndex={buttonIndex}
        isSelected={buttonIndex === currentIndex}
        {...contents}
        picture={picture}
      />
    </Button>
  );
};

PaginationButton.propTypes = {
  buttonIndex: PropTypes.number.isRequired,
  carouselsStoreDataKey: PropTypes.string.isRequired,
  setIndex: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  contents: PropTypes.objectOf(PropTypes.any),
  currentIndex: PropTypes.number.isRequired,
  onIndexChange: PropTypes.func,
};

export default PaginationButton;
